module.exports = __webpack_public_path__ + "img/Icon-scroll-panonav.b3732bec.svg";